import { useSalesQuery } from '@/hooks/sale/queries/use-sales.query';
import SaleDisplay from '@/partials/sale/sale-display';
import SkeletonWrapper from '@/components/ui/skeleton-wrapper';
import NoSales from '@/partials/sale/no-sales';
import { Navigate } from 'react-router-dom';
import CreateSaleDisplay from '@/partials/sale/create-sale-display';
import { useAuth } from '@/hooks/auth/use-auth';
import { MembershipRole } from '@/types/api/membership';
import { SaleStatus } from '@/types/api/sale';

export default function Sales() {
  const { context } = useAuth();
  const { data: sales, isPending, isError } = useSalesQuery();

  if (isError) return 'Fel';

  const showSales = isPending || Boolean(sales.length);

  if (sales?.length === 1) {
    return <Navigate to={sales[0].id} />;
  }

  return (
    <>
      {/* Page header */}
      <div className="sm:flex sm:justify-between sm:items-center mb-5">
        {/* Left: Title */}

        <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Era försäljningar</h1>
      </div>

      {showSales ? (
        <div className="gap-4 grid grid-cols-6">
          <SkeletonWrapper
            isPending={isPending}
            containerClassName="col-span-6 lg:col-span-3 xl:col-span-2"
            count={3}
            height={200}
          >
            {sales?.map((sale) => (
              <SaleDisplay {...sale} key={sale.id} />
            ))}

            {context?.membershipRoles.includes(MembershipRole.Leader) &&
              !sales?.some((sale) => sale.status === SaleStatus.Active) && <CreateSaleDisplay key="create" />}
          </SkeletonWrapper>
        </div>
      ) : (
        <NoSales />
      )}
    </>
  );
}
